import TitleSection from 'components/common/TitleSection';
import OurTeamCard from 'components/common/cards/OurTeamCard';
import { ourTeamCardData } from 'helpers/commonHelper';

const OurTeamListing = () => {
  const titleDetail = {
    upperTitle: '',
    middleTitle: 'oUR TEAM',
    ceoDesignation: 'WE HAVE BEST SOLUTIONS FOR ALL',
  };
  return (
    <section className='DBlock py-10 sm:py-12 px-6 sm:px-10 bg-eventLightPink'>
      <div className='max-w-7xl mx-auto'>
        <div className='DBlock'>
          <TitleSection titleDetail={titleDetail} />
        </div>
        <div className='DBlock'>
          <div className='grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-6'>
            {ourTeamCardData?.map((list) => (
              <OurTeamCard data={list} />
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default OurTeamListing;
